import React, { useMemo } from 'react';
import ProFormaReturnsTable from 'components/ProFormaReturnsTable/ProFormaReturnsTable';
import { getPeriodKeys, transformReturnsData } from 'views/ProFormaTable/components/ReturnsAndWaterfall/Returns/helpers';
import { IProFormaReturnsData } from 'views/ProFormaTable/types';

export interface IProps {
    data: IProFormaReturnsData;
    operationBeginMonth: number;
    cadence: string;
}

export const AggregateProFormaReturnsTable = ({ data, operationBeginMonth, cadence }: IProps) => {
    const dateKeys = useMemo(() => getPeriodKeys(data, cadence), [data, cadence]);
    const transformedData = useMemo(() => transformReturnsData(data, cadence), [data, cadence]);

    return (
        <div className="pt-2">
            <ProFormaReturnsTable
                showCents
                propertyReturns={transformedData}
                dateKeys={dateKeys}
                operationBeginMonth={operationBeginMonth}
                cadence={cadence}
            />
        </div>
    );
};

export default AggregateProFormaReturnsTable;
